import TagManager from "react-gtm-module";

export function initializeGoogleTagManager(gtmId: string, whitelist: string[]): boolean {
  if (typeof window === "undefined" || !gtmId || whitelist.length === 0) {
    return false;
  }

  TagManager.initialize({
    gtmId,
    dataLayer: {
      "gtm.whitelist": whitelist,
    },
  });
  return true;
}

const UUID_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;

// Query strings are left out because application screens can carry applicant data in them, and
// UUIDs are replaced so each application's screens aggregate under one path.
export function trackGoogleTagManagerPageView(rawPathname: string) {
  const pathname = rawPathname.replace(UUID_PATTERN, ":uuid");
  TagManager.dataLayer({
    dataLayer: {
      event: "virtual_page_view",
      page_path: pathname,
      page_location: `${window.location.origin}${pathname}`,
      page_title: document.title,
    },
  });
}
